import React from 'react'
import { useSelector } from 'react-redux'
import MovieList from "./MovieList"

const GptMovieSuggestion = () => {
  const gpt = useSelector((store) => store.gpt);
  const {moviesResult, movieNames} = gpt;
  if(!movieNames) return null;

  return (
    <div className='p-4 m-4 bg-black text-white bg-opacity-60'>
      {movieNames.map((movieName, index) => <MovieList key={movieName} title={movieName} Movies={moviesResult[index]}/> )}
    </div>
  )
}

export default GptMovieSuggestion